module.exports = __webpack_public_path__ + "img/milestone__02.61a02eac.png";